import { token } from '@cp/shared/di';

export const AUTH_FEATURE = token<() => Promise<unknown>>('catalogItem/AUTH_FEATURE');
